module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/Payments/images/credit-card-default-fc95b5a156a062758e220006bd8bc1ea.svg";